import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Import page components
import HomePage from "@/components/pages/HomePage";
import EventPage from "@/components/pages/EventPage";
import AforoPanel from "@/components/pages/AforoPanel";
import QRScanner from "@/components/pages/QRScanner";
import PrivacyPolicy from "@/components/pages/PrivacyPolicy";
import PaymentSuccess from "@/components/pages/PaymentSuccess";
import MesaPaymentSuccess from "@/components/pages/MesaPaymentSuccess";
import BonocopaPaymentSuccess from "@/components/pages/BonocopaPaymentSuccess";
import BarraPanel from "@/components/pages/BarraPanel";
import AdminPanel from "@/components/admin/AdminPanel";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/events/:eventId" element={<EventPage />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/scanner" element={<QRScanner />} />
          <Route path="/aforo" element={<AforoPanel />} />
          <Route path="/barra" element={<BarraPanel />} />
          <Route path="/privacidad" element={<PrivacyPolicy />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/mesa-success" element={<MesaPaymentSuccess />} />
          <Route path="/bonocopa-success" element={<BonocopaPaymentSuccess />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
